import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useArcadeSpotCleanup = () => {
  useEffect(() => {
    const cleanupPendingSpots = async () => {
      try {
        //console.log('🧹 Cleaning up pending arcade spots...');
        await supabase.functions.invoke('cleanup-pending-arcade-spots');
      } catch (error) {
        //console.warn('Failed to cleanup pending arcade spots:', error);
      }
    };

    // Nettoyer au démarrage
    cleanupPendingSpots();

    // Nettoyer toutes les 2 minutes
    const interval = setInterval(cleanupPendingSpots, 2 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);
};